module.exports = __webpack_public_path__ + "img/7.88607cd7.gif";